import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { Alert } from "/WebInterface/new-ui/modules/alert.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import {
  setLanguage,
  t,
} from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

const loginPageUrl = "/WebInterface/login.html";

async function doReset() {
  const password1 = utils.encodeURILocal(_$("#password").val());
  const password2 = utils.encodeURILocal(_$("#passwordConfirm").val());
  if (password1 != password2) {
    growl(
      t("passwordAndConfirmPasswordAreNotTheSame"),
      t("passwordsDoNotMatch"),
      5000,
      true
    );
    _$("#passwordConfirm").el().focus();
    return false;
  }

  const username = _$("#reset_1").val();
  const curLang = utils.storage.get("_i18n") || "en";

  const loading = new Loader({
    parentElement: "#resetFormContainer",
  });

  try {
    const resp = await ajax.call({
      data: {
        command: _$("#command").val(),
        reset_username_email: utils.encodeURILocal(username),
        password1: password1,
        password2: password2,
        resetToken: utils.encodeURILocal(_$("#resetToken").val()),
        currentURL:
          location.protocol + "//" + location.host + location.pathname,
        language: curLang,
        random: crypto.getRandomValues(new Uint32Array(1))[0],
      },
    });

    const xml = new DOMParser().parseFromString(resp, "text/xml");
    const result = utils.xmlToJson(xml);

    const { response } = result.commandResult;
    const decoded = decodeURIComponent(response);
    const isError = decoded.indexOf("ERROR: ") === 0;
    if (isError) {
      const passUrlLine = decoded
        .split(/\r?\n/)
        .find((line) => line.startsWith("PASS_URL:"));
      const unsafeChars = passUrlLine
        ? passUrlLine.slice("PASS_URL:".length)
        : null;
      if (unsafeChars) {
        growl(
          `${t("forbiddenCharacters")}: ${utils.sanitizePure(unsafeChars)}`,
          t("passwordContainsForbiddenCharacters"),
          5000,
          true
        );
      } else {
        growl("", utils.sanitizePure(decoded.split(/\r?\n/)[0]), 5000, true);
      }
    } else {
      Alert({
        type: "confirm",
        cancel: null,
        title: t("loginWithNewPassword"),
        body: t("pleaseLoginAgain"),
        confirm: {
          label: t("backToLogin"),
          close: true,
          onClick: () => {
            location.href = loginPageUrl;
          },
        },
        closable: false,
        submitOnEnter: false,
      });
    }
  } catch (error) {
    growl("", utils.sanitizePure(decodeURIComponent(error)), 5000, true);
  } finally {
    loading.deleteLoader();
  }
}

async function sendResetRequest() {
  const username = _$("#reset_1").val();
  const curLang = utils.storage.get("_i18n") || "en";

  const obj = {
    command: _$("#command").val(),
    reset_username_email: utils.encodeURILocal(username),
    currentURL:
      document.location.protocol +
      "//" +
      document.location.host +
      document.location.pathname,
    language: curLang,
    random: crypto.getRandomValues(new Uint32Array(1))[0],
  };

  const formBody = Object.entries(obj)
    .map(
      ([key, value]) =>
        `${utils.encodeURILocal(key)}=${utils.encodeURILocal(value)}`
    )
    .join("&");

  const loading = new Loader({
    parentElement: "#resetFormContainer",
  });

  try {
    const resp = await ajax.call({
      data: formBody,
      urlEncoded: true,
      skipC2F: true,
    });
    const xml = new DOMParser().parseFromString(resp, "text/xml");
    const result = utils.xmlToJson(xml);

    const { response } = result.commandResult;

    growl(utils.sanitizePure(utils.decodeURILocal(response)), "", 5000, false);
  } catch (error) {
    if (!error) errorThrown = "Error";
    growl(utils.sanitizePure(errorThrown), "", 5000, false);
  } finally {
    loading.deleteLoader();
  }
  return false;
}

const bindPasswordToggle = (toggleId, inputId) => {
  const btn = document.getElementById(toggleId);
  const inp = document.getElementById(inputId);
  if (!btn || !inp) return;
  const icon = btn.querySelector("i");
  btn.addEventListener("mousedown", () => {
    inp.type = "text";
    icon.className = "icon-eye-open";
  });
  btn.addEventListener("mouseup", () => {
    inp.type = "password";
    icon.className = "icon-eye-close";
  });
  btn.addEventListener("mouseleave", () => {
    inp.type = "password";
    icon.className = "icon-eye-close";
  });
  btn.addEventListener("touchstart", (e) => {
    e.preventDefault();
    inp.type = "text";
    icon.className = "icon-eye-open";
  });
  btn.addEventListener("touchend", (e) => {
    e.preventDefault();
    inp.type = "password";
    icon.className = "icon-eye-close";
  });
};

async function fetchPasswordRulesForToken(token) {
  try {
    const resp = await ajax.call({
      data: {
        command: "getPasswordRulesForToken",
        resetToken: utils.encodeURILocal(token),
        random: crypto.getRandomValues(new Uint32Array(1))[0],
      },
    });
    const xml = new DOMParser().parseFromString(resp, "text/xml");
    const result = utils.xmlToJson(xml);
    const rules = result?.commandResult;

    const tokenCustomizations = {};
    if (
      rules &&
      rules.web_customizations &&
      rules.web_customizations.customization
    ) {
      const customItems = Array.isArray(rules.web_customizations.customization)
        ? rules.web_customizations.customization
        : [rules.web_customizations.customization];

      customItems.forEach((item) => {
        if (item && item.key && item.value) {
          const key = decodeURIComponent(item.key);
          const value = decodeURIComponent(item.value);
          tokenCustomizations[key] = value;
        }
      });
    }

    // Hide Generate Password button
    if (tokenCustomizations["HideUserOptionGeneratePassword"] === "true") {
      _$("#btnGeneratePassword").addClass("is-hidden");
    } else {
      _$("#btnGeneratePassword").removeClass("is-hidden");
    }

    // Logo clickable customization
    if (tokenCustomizations["linkOnLogo"]) {
      const logoImg = document.querySelector("img.logo");
      if (logoImg && logoImg.parentElement.tagName.toLowerCase() !== "a") {
        const linkWrapper = document.createElement("a");
        linkWrapper.href = tokenCustomizations["linkOnLogo"];
        linkWrapper.target = "_blank";
        logoImg.parentNode.insertBefore(linkWrapper, logoImg);
        linkWrapper.appendChild(logoImg);
        logoImg.style.cursor = "pointer";
      }
    }

    if (rules && typeof rules === "object") {
      if (!window.passwordRule || typeof window.passwordRule !== "object") {
        window.passwordRule = {};
      }
      const intFields = [
        "random_password_length",
        "min_password_length",
        "min_password_numbers",
        "min_password_lowers",
        "min_password_uppers",
        "min_password_specials",
      ];
      intFields.forEach((key) => {
        if (rules[key] !== undefined && rules[key] !== "") {
          window.passwordRule[key] = parseInt(rules[key]);
        }
      });
      if (rules.unsafe_password_chars !== undefined) {
        window.passwordRule.unsafe_password_chars = utils.decodeURILocal(
          rules.unsafe_password_chars
        );
      }
    }
  } catch (e) {}
}

const init = async () => {
  const queryString = location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");
  const username = urlParams.get("username");

  if (token) {
    _$(".resetPanel").removeClass("is-hidden");

    _$("#command").val("reset_password");
    _$("#resetToken").val(token).attr("readonly", "readonly");

    if (!username) {
      _$("#usernameFieldContainer").addClass("is-hidden");
    } else {
      _$("#reset_1").val(username).attr("readonly", true);
    }
    await fetchPasswordRulesForToken(token);
  } else {
    if (username) {
      _$("#reset_1").val(username);
    }
  }

  bindPasswordToggle("togglePassword", "password");
  bindPasswordToggle("togglePasswordConfirm", "passwordConfirm");

  _$("#btnGeneratePassword").on("click", () => {
    const generatedPassword = utils.generatePasswordBasedOnRules();
    _$("#generated_password").val(generatedPassword);
    _$("#generatePasswordPanel").removeClass("is-hidden");
  });

  _$("#usePassword").on("click", () => {
    const generatedPassword = _$("#generated_password").val();
    _$("#password,#passwordConfirm").val(generatedPassword);
  });

  _$("#cancelPassword").on("click", () => {
    _$("#generatePasswordPanel").addClass("is-hidden");
  });

  _$("#resetForm").on("submit", (e) => {
    e.preventDefault();

    if (token) {
      doReset();
    } else {
      sendResetRequest();
    }
  });
};

const applyCustomizations = () => {
  const login_page_default_theme =
    window.customizations?.login_page_default_theme;
  const brandingImagePath =
    window.brandingImagePath && utils.sanitizePure(window.brandingImagePath);

  if (
    login_page_default_theme ||
    typeof login_page_default_theme === "string"
  ) {
    _$("[data-theme]").attr("data-theme", login_page_default_theme);
    localStorage.setItem("data-theme", login_page_default_theme);
  }

  const loginLanguagesAllowlist = utils.getLoginPageLanguagesAllowlist();
  if (loginLanguagesAllowlist) {
    utils.filterLanguagesToShow(loginLanguagesAllowlist);
  }

  if (window.customizations?.login_page_default_language) {
    setLanguage(window.customizations?.login_page_default_language);
  }

  if (window.customizations?.login_page_show_language_selection === "false") {
    _$("w-language").remove();
  }

  if (window.customizations?.login_page_column_style === "single") {
    _$(".reset-banner-container").remove();
  } else {
    _$(".reset-banner-container").removeClass("is-hidden");
  }

  if (window.customizations?.login_page_column_style === "double-reverse") {
    _$("#page-columns").addClass("is-flex-direction-row-reverse");
  }

  if (window.customizations?.login_page_save_languages_selection === "true") {
    const selectedLanguage = _$("html").attr("lang");
    localStorage.setItem("selected-language", selectedLanguage);
  }

  if (brandingImagePath) {
    const authBanner = _$("#reset-banner");
    authBanner.attr("src", brandingImagePath);
  }
};

_$("body").ready(() => {
  init();
  applyCustomizations();

  _$("#backToLogin").on("click", () => {
    location.href = "/WebInterface/login.html";
  });
});
